export default __webpack_public_path__ + "24837b2dc937c6b76ff0057db131ec2c.svg";